import type {FC} from 'react';

import type {PosterHeadingSchema} from 'components/page-heading/poster-heading/schema';
import type {HeadingSchema} from 'components/page-heading/schema';

import {PosterHeading} from './poster-heading';
import {TextHeading} from './text-heading';

interface Props {
	activeHeading?: HeadingSchema | PosterHeadingSchema;
}

export const Heading: FC<Props> = ({activeHeading}) => {
	switch (activeHeading?._type) {
		case 'textHeading':
			return <TextHeading data={activeHeading} />;
		case 'posterHeading':
			return <PosterHeading data={activeHeading} />;
		default:
			return null;
	}
};
